export const ROUTE_PATH = '/invite-error';

export const INVALID_TOKEN_STRATEGY = 'invalid-invite-token';
